// extracted by mini-css-extract-plugin
export var wrapper = "contact-module--wrapper--kf0hQ";
export var contact__info = "contact-module--contact__info--ehHyS";
export var socials = "contact-module--socials--r3LQX";
export var hours = "contact-module--hours--t74dt";
export var contact__map = "contact-module--contact__map--Jw+SU";
export var contact = "contact-module--contact--Iuov3";